module.exports = __webpack_public_path__ + "img/heading_uk.09a071ae.svg";